/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ms-ComboBoxBasicExample{max-width:300px}\n"}]);